<template>
   <section class="flex h-full grow items-center bg-brand-dark text-center text-white">
      <div class="container flex max-w-xl flex-col items-center justify-center">
         <ResumePrivateFlow
            v-if="isPrivateFlow"
            data-cy="resume-private-flow"
            @go-to-last-block="$emit('go-to-last-block')"
            @go-to-first-block="$emit('go-to-first-block')"
         />
         <ResumePublicFlow
            v-else
            data-cy="resume-public-flow"
            :userBlockIdHistory="userBlockIdHistory"
            :participationResetConfirmed="participationResetConfirmed"
            @go-to-last-block="$emit('go-to-last-block')"
            @go-to-first-block="
               (response) => {
                  $emit('go-to-first-block', response);
               }
            "
            @update-user-block-id-history="
               (response) => {
                  $emit('update-user-block-id-history', response);
               }
            "
            @public-resume-show-participation-reset-message="$emit('public-resume-show-participation-reset-message')"
         />
      </div>
   </section>
</template>

<script setup lang="ts">
// Props & emits
// ------------------------------
interface Props {
   isPrivateFlow: boolean;
   userBlockIdHistory: string[];
   participationResetConfirmed?: boolean;
}

defineProps<Props>();

const $emit = defineEmits([
   "go-to-last-block",
   "go-to-first-block",
   "update-user-block-id-history",
   "public-resume-show-participation-reset-message",
]);
</script>
